import { PropsWithChildren, useRef } from 'react'

import { useCreation } from 'ahooks'

import { RemoteTableStoreRef } from '@eastcoal/common/components/RemoteTable/Store/interface'

import { PriceCompareListStoreContext } from './contexts/StoreContext'
import { createPriceCompareListStore } from './store/createStore'

export const PriceCompareListStoreProvider = ({
  children
}: PropsWithChildren) => {
  const tableRef = useRef<RemoteTableStoreRef>(null)
  const store = useCreation(() => createPriceCompareListStore({ tableRef }), [])

  return (
    <PriceCompareListStoreContext value={store}>
      {children}
    </PriceCompareListStoreContext>
  )
}
